import { create } from 'zustand';

type PartnersDialog = 'demo' | 'login' | 'guide' | null;

interface PartnersDialogStore {
  dialog: PartnersDialog;
  openDemoDialog: () => void;
  openLoginDialog: () => void;
  openGuideDialog: () => void;
  closeDialog: () => void;
}

export const usePartnersDialog = create<PartnersDialogStore>((set) => ({
  dialog: null,
  openDemoDialog: () => set({ dialog: 'demo' }),
  openLoginDialog: () => set({ dialog: 'login' }),
  openGuideDialog: () => set({ dialog: 'guide' }),
  closeDialog: () => set({ dialog: null }),
}));
